import React, { Component } from "react";
import "./Portabilidade.css";
import "./Portability.css";
import "../../style/normalize.css";
// import imgPort from "../../images/bg-portabilidade.svg";

import InfoMainsPortability from "./portability-info-main";
import InfoFooterPortability from "./portability-info-footer";
import FormPortability from "./portability-form";

import PortabilityAbout from "./components/PortabilityAbout";
import { getPortabilityParams } from "./getPortabilityParams";

class Portability extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cpf: "",
      name: "",
      oldNumber: "",
      newNumber: "",
      operadora: "",
      opacity1: false,
      token: "",
    };
  }

  render() {
  const portabilityParams = getPortabilityParams();

    return (
      <div className="content-portabilidade portability-container ">
        <div className="content-portabilidade">
          <div className="shell-portabilidade portability-content">
            <InfoMainsPortability />

            <FormPortability />

            {!portabilityParams.hideAbout ? (
              <PortabilityAbout />
            ) : null}
          </div>
        </div>
        {!portabilityParams.hideImage ? (
          <div className="content-portabilidade-out">
            <img  alt="img-portability"src={"https://pagtel.com.br/img/correios/portabilidade.png"} width="300" />
          </div>
        ) : null}
      </div>
    );
  }
}

export default Portability;
